module.exports = {
	init: function () {
        $('#tax_exempt').on('change', function() {
            jQuery(document.body).trigger('update_checkout');
        })
    }
}